import gsap from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger'

const list = document.querySelector('.slideshow-list')

gsap.registerPlugin(ScrollTrigger);

let sections = gsap.utils.toArray(".slideshow-list__el");

gsap.to(sections, {
  xPercent: -140 * (sections.length -1),
  ease: "none",
  scrollTrigger: {
    id: 1,
    trigger: list,
    pin: true,
    scrub: 1,
    end: () => "+=" + list.offsetWidth
  }
});
